import { useCallback, useMemo, useState } from 'react'

import { GridRowId, GridSortItem } from '@mui/x-data-grid'
import { useHistory, useLocation } from 'react-router-dom'

import { FplDataGrid } from 'components/common'
import { GET_PAGED_AVAILABLE_LOADS } from 'graphql/queries'
import useGetAvailableLoadsColumns from 'hooks/fplDataGridColumns/useGetAvailableLoadsColumns'

import SubmitBidDialog from './SubmitBidDialog'

const SUBMIT_BID_PARAM = 'submitBid'

function AvailableLoads() {
  const history = useHistory()
  const location = useLocation()

  // Opened from the "New job available" email link: /dashboard?submitBid={bookingId}#dashboard-available-loads
  const [submitBidDialog, setSubmitBidDialog] = useState<{
    id: number | null
    open: boolean
  }>(() => {
    const bookingId = Number(new URLSearchParams(location.search).get(SUBMIT_BID_PARAM))

    return bookingId > 0 ? { id: bookingId, open: true } : { id: null, open: false }
  })

  const handleSubmitBidClick = useCallback(
    (id: GridRowId) => () => {
      setSubmitBidDialog({
        id: Number(id),
        open: true,
      })
    },
    [setSubmitBidDialog],
  )

  const handleCloseSubmitBidDialog = () => {
    setSubmitBidDialog({
      id: null,
      open: false,
    })

    const searchParams = new URLSearchParams(location.search)

    if (searchParams.has(SUBMIT_BID_PARAM)) {
      searchParams.delete(SUBMIT_BID_PARAM)
      history.replace({ search: searchParams.toString(), hash: location.hash })
    }
  }

  const columns = useGetAvailableLoadsColumns(handleSubmitBidClick)

  const queryData = useMemo(
    () => ({
      query: GET_PAGED_AVAILABLE_LOADS,
      entityName: 'availableLoads',
      defaultSortOrder: {
        field: 'ourReference',
        sort: 'desc',
      } as GridSortItem,
    }),
    [],
  )

  return (
    <>
      <FplDataGrid
        query={queryData.query}
        isHideOldData={true}
        refetchWithDelay
        entityName={queryData.entityName}
        variableSortOrder={queryData.defaultSortOrder}
        toolbar={{
          caption: 'Available Loads',
        }}
        disableSelectionOnClick
        columns={columns}
      />
      <SubmitBidDialog
        bookingId={submitBidDialog.id}
        open={submitBidDialog.open}
        onClose={handleCloseSubmitBidDialog}
      />
    </>
  )
}

export default AvailableLoads
